const WarehousePacking = `
  id
  description
	updatedAt
`;

export default WarehousePacking;
